<template>
  <div>
    <div id="contacts-section" class="footer-color">
      <div class="container">
        <b-row class="footer-view">
          <b-col cols="12" md="10">
            <div class="footer-link">
              <div class="footer-project">
                <ul>
                  <li>项目机会</li>
                  <li v-if="!hasPhone">|</li>
                  <li
                    v-for="(item, index) in project"
                    :key="index"
                    @click="ToRouter(item.id, '/product')"
                  >
                    {{ item.name }}
                  </li>
                </ul>
              </div>
              <div class="footer-new">
                <ul>
                  <li
                    v-for="(item, index) in newData"
                    :key="index"
                    @click="ToRouter(item.to)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
              <div class="footer-about">
                <ul>
                  <li>关于我们</li>
                  <li v-if="!hasPhone">|</li>
                  <li
                    v-for="(item, index) in about"
                    :key="index"
                    @click="ToRouter(item.to)"
                  >
                    {{ item.title }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="footer-message">
              <div class="footer-new" style="margin-top:10px;" v-if="hasPhone">
                <ul>
                  <li>联系我们</li>
                </ul>
              </div>

              <div
                class="footer-message-content"
                v-for="(item, index) in message"
                :key="index"
              >
                <div class="message-content-header">
                  <i :class="[item.icon]"></i>
                  <p>{{ item.title }}</p>
                </div>
                <p>{{ item.text }}</p>
              </div>
            </div>
          </b-col>
          <b-col cols="12" md="2">
            <div class="footer-wx">
              <img src="@/assets/img/new/footer/wx.png" />
              <p>扫一扫关注小程序</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <footer
      class="g-bg-gray-dark-v1 footer-texts g-py-20"
      style="position:relative"
    >
      <div class="container">
        <div class="row footer-boms" style="justify-content: center;">
          <div class="arrow-top" @click="toTop">
            <img src="@/assets/img/new/footer/arrow-top.png" alt />
          </div>
          <p>
            Copyright © 2020
            <span>huicaihuineng.com</span>. All Rights Reserved.
            汇才汇能（北京）科技有限公司 版权所有
            <span style="cursor:pointer" @click="outSideLink"
              >京ICP备20028335号-2</span
            >
          </p>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import "../assets/css/unify.css";
import utils from "@/assets/js/index.js";
import Api from "@/apis";
export default {
  data() {
    return {
      gotop: false,
      hasPhone: false,
      project: [
        {
          title: "尽职调查咨询",
          to: "/project/diligence"
        },
        {
          title: "IT审计和咨询",
          to: "/project/it"
        },
        {
          title: "数字化转型咨询",
          to: "/project/digital"
        }
      ],
      newData: [
        {
          title: "新闻资讯",
          to: "/new"
        }
      ],
      about: [
        {
          title: "公司介绍",
          to: "/about/introduction"
        },
        {
          title: "联系我们",
          to: "/about/contact"
        },
        {
          title: "加入我们",
          to: "/about/join"
        }
      ],
      message: [
        {
          title: "地址",
          icon: "icon-address",
          text: "北京市海淀区杏石口路80号B区1号楼一层125号"
        },
        {
          title: "邮箱",
          icon: "icon-email",
          text: "hchn_hr@163.com"
        },
        {
          title: "网址",
          icon: "icon-www",
          text: "www.huicaihuineng.com"
        }
      ]
    };
  },
  mounted() {
    // this.getSolutionData();
    window.addEventListener("scroll", this.handleScroll, true);
    this.getProjectCategories();
    if (this._isMobile()) {
      this.hasPhone = true;
    } else {
      this.hasPhone = false;
    }
  },
  methods: {
    async getSolutionData() {
      const query = {
        pageSize: 10,
        current: 1
      };
      try {
        const data = await Api.CMS.getCms("solution", query);
        if (data.data.length > 0) {
          this.FooterData[1].children.push({
            text: "解决方案",
            href: "solution"
          });
        }
      } catch (e) {
        this.$message.error(e);
      }
    },
    async getProjectCategories() {
      try {
        const query = {
          current: 1,
          filters: {
            flagRecommend: 1
          }
        };
        const data = await Api.Project.getProjectCategories(query);
        const cateData = data.data;
        this.project = cateData;
      } catch (e) {
        this.$message.error(e);
      }
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    outSideLink() {
      window.location.href = "https://beian.miit.gov.cn/#/Integrated/index";
    },
    handleScroll() {
      let scrolltop =
        document.documentElement.scrollTop || document.body.scrollTop;
      scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop;
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
        if (top <= 0) {
          clearInterval(timeTop);
        }
      }, 10);
    },
    ToRouter(href, path) {
      if (path) {
        this.$router.push({
          path: path,
          query: {
            id: href
          }
        });
      } else {
        utils.toRouters(this, href);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.footer-color {
  background: #f7f8ff;
  p {
    color: #666;
  }
}
.footer-texts {
  background: #d7d9e6 !important;
  p {
    color: #333333;
    span {
      color: #3382ff;
    }
  }
}
</style>
